// REACT IMPORTS
import React from "react";

// MUI COMPONENTS
import { Tooltip } from "@mui/material";

// MUI ICONS
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

// Where each calculated value on the Product Library comes from. Values that
// are plain HubSpot product properties don't need one.
export const HELP = {
	uses: "Number of line items that use this product, on Proposal Pipeline deals created in the last year. Can be up to 6 hours behind HubSpot.",
	typicalHours:
		"Median hours on line items that use this product, on Proposal Pipeline deals created in the last year. Phase fee adjustment lines aren't counted. Can be up to 6 hours behind HubSpot.",
	hoursRange:
		"Fewest and most hours on line items that use this product, on Proposal Pipeline deals created in the last year. Can be up to 6 hours behind HubSpot.",
	editedPct:
		"Share of those line items whose wording differs from the product's current name. Spacing, quote style and a trailing period don't count as edits.",
	lastUsed:
		"Created date of the most recent Proposal Pipeline deal with a line item that uses this product. Can be up to 6 hours behind HubSpot.",
	editor: "Whether the product is offered in the Line Item Editor's library. Phase fee lines (_ADJUSTMENT) aren't, because the editor sets them from the phase fee. Accounting items in the QBO folder and retired products aren't either.",
	sets: "Set by Tools, not HubSpot. The standard sets that include this product, which add it with one click in the Line Item Editor's library.",
	recentDeals:
		"Line items that use this product, newest deal first, from Proposal Pipeline deals created in the last year.",
	wording:
		"Edited when the line item's wording differs from the product's current name. Spacing, quote style and a trailing period don't count. Hover an Edited tag to see that deal's wording.",
};

/**
 * A label followed by the site's "?" icon (as in the Project Viewer's
 * schedule legend), which explains the value on hover
 * @param {string} props.label
 * @param {string} props.help
 */
const HelpLabel = ({ label, help }) => (
	<span className="productLibraryExplainedHeader">
		{label}
		<Tooltip title={help} arrow placement="top">
			<HelpOutlineIcon
				style={{ fontSize: 16, color: "#b6bcc7", cursor: "default" }}
			/>
		</Tooltip>
	</span>
);

export default HelpLabel;
